function SkeletonMessage({ index = 0 }) {
  const lengths = ['w-18 lg:w-36', 'w-32 lg:w-64', 'w-36 lg:w-72'] as const;
  const width = lengths[index % lengths.length];

  return (
    <div className="flex max-w-[stretch] shrink animate-pulse justify-start space-x-4 align-top odd:animate-[pulse_2s_ease-in-out_1s_infinite]">
      <div className="h-8 w-8 rounded-sm bg-zinc-200 dark:bg-white/20" />
      <div>
        <div className="flex max-w-[stretch] shrink flex-row items-end space-x-2">
          <div className="h-4 w-8 rounded-sm bg-zinc-200 dark:bg-white/20" />
          <div className="h-3 w-12 max-w-[stretch] shrink rounded-sm bg-zinc-200 dark:bg-white/20" />
        </div>
        <div
          className={`mt-2 h-4 ${width} max-w-[stretch] shrink rounded-sm bg-zinc-200 dark:bg-white/20`}
        />
      </div>
    </div>
  );
}

function SkeletonMessages({ messages = 24 }) {
  return (
    <div className="space-y-4 overflow-hidden p-4">
      {Array(messages)
        .fill(1)
        .map((_, index) => (
          <SkeletonMessage key={index} index={index} />
        ))}
    </div>
  );
}

export default SkeletonMessages;
